import { AxiosError } from "axios"
import { useCallback, useState } from "react"
import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"

import { useAccessToken } from "@/hooks/useAccessToken"
import { useAppToast } from "@/hooks/useAppToast"
import { exitImpersonation } from "@/networking/impersonation"
import { ADMIN_PATHS, PATHS } from "@/routing/paths"

export const useExitImpersonation = () => {
  const { setAccessToken } = useAccessToken()
  const navigate = useNavigate()
  const toast = useAppToast()
  const intl = useIntl()
  const [isLoading, setIsLoading] = useState(false)

  const exit = useCallback(async () => {
    setIsLoading(true)
    try {
      const { token } = await exitImpersonation()
      setAccessToken(token)
      navigate(`${PATHS.ADMIN}${ADMIN_PATHS.USERS}`)
    } catch (err) {
      const data = err instanceof AxiosError ? err.response?.data : undefined
      const description =
        typeof data === "object" &&
        data !== null &&
        "hydra:description" in data &&
        typeof data["hydra:description"] === "string"
          ? data["hydra:description"]
          : undefined

      toast({
        status: "error",
        title: intl.formatMessage({ id: "impersonation.exit.error.title" }),
        description: description ?? intl.formatMessage({ id: "impersonation.exit.error.generic" }),
      })
    } finally {
      setIsLoading(false)
    }
  }, [intl, navigate, setAccessToken, toast])

  return { exit, isLoading }
}
